export const jobStatusFilterOptions = [
  { label:"Job Lead", value: "Job Lead" },
  {
    label: "Material and Trucking Details",
    value: "Material and Trucking Details",
  },
  { label: "Build Quote", value: "Build Quote" },
  { label: "Quote Shared", value: "Quote Shared" },
  { label: "Quote Approved", value: "Quote Approved" },
  { label: "Internal Approval Draft", value: "Internal Approval Draft" },
  { label: "L1 Approval Pending", value: "L1 Approval Pending" },
  { label: "L1 Rejected", value: "L1 Rejected" },
  { label: "L2 Approval Pending", value: "L2 Approval Pending" },
  { label: "L2 Rejected", value: "L2 Rejected" },
  { label: "L2 Approved", value: "L2 Approved" },
  {
    label: "Internal Approval Completed",
    value: "Internal Approval Completed",
  },
  { label: "Dispatch Approved", value: "Dispatch Approved" },
];

export const JobDetailsConsts = {
   NO_ACCESS_CUSTOMER_DB: "Access required to view Customer Profile",
   BLOCKED_ICON_ALT: "Blocked Job",
}
